/**
 * @prettier
 */

import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import { Link } from '@zola/zola-ui/src/components/Link';
import infoIcon from 'assets/images/invitations/single-sample-modal/info.svg';
import { openModal as openModalAction } from 'cards/actions/modalActions';
import { getMultiSampleState } from 'cards/selectors/singlesample';
import { useMobileCheck } from '../util/hooks';
import styles from './styles.module.less';

export const MaxSamplesHintBase = ({ className, multiSampleState, openModal }) => {
  const isMobile = useMobileCheck();

  if (isMobile || !multiSampleState.enabled) {
    return null;
  }

  const { limit } = multiSampleState.count;

  const hasNoOrders = multiSampleState.count.ordersPlaced === 0;

  if (hasNoOrders) {
    return null;
  }

  return (
    <div className={cx(className, styles.toggleLabelBox)}>
      <img alt="" src={infoIcon} className={styles.learnMoreInfoIcon} />
      <span>
        You can order up to {limit} more sample{limit === 1 ? '' : 's'} for free!&nbsp;
        <Link role="button" onClick={openModal}>
          Learn more
        </Link>
      </span>
    </div>
  );
};

export const mapStateToProps = state => ({
  multiSampleState: getMultiSampleState(state),
});

export const mapDispatchToProps = dispatch => ({
  openModal: () =>
    dispatch(
      openModalAction(
        'SINGLE_SAMPLE_LIMIT_SCREEN',
        {},
        {
          bottomModalOnMobile: true,
          className: styles.modal,
        }
      )
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(MaxSamplesHintBase);
